import {Answer} from 'Models'
import includes from 'ramda/es/includes'
import head from 'ramda/es/head'
import equals from 'ramda/es/equals'
import {calcSimplePoints} from '../_common/pointsCalculationHelper';

export const calculatePoints = answer => {
    const userInput         = head(answer.userInput())
    const question          = answer.question()
    const expectedAnswers   = question.correctAnswers() // = [{ "?":["x", "y"] }, ...]
    const isCountPerAnswer  = question.countPerAnswer()
    const points            = () => Number(question.points())

    if(!userInput || !userInput.value)
            return 0

    const answers       = userInput.value.answerData
    const correctOnes   = () => expectedAnswers.map( (ea,i) => {
            const groupID = 'group_'+i
            return answers[groupID].map( a => includes(a, ea.elements))
                                   .every( equals(true) )
        })
        .filter( x => x===true).length

    return isCountPerAnswer ? correctOnes()*points() : calcSimplePoints(answer)
}